import Vue from 'vue';
import * as VeeValidate from 'vee-validate';
import VueMoment from 'vue-moment';
import Vue2Filters from 'vue2-filters';
import Vue2Editor from 'vue2-editor';
import VJsoneditor from 'v-jsoneditor';
import sanitizeHTML from 'sanitize-html';

import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { auth, db } from '@/plugins/firebase';

// Global Components
import '@/globalComponents';

const vue2FiltersConfig = {
  capitalize: {
    onlyFirstLetter: false,
  },
  number: {
    format: '0',
    thousandsSeparator: ',',
    decimalSeparator: '.',
  },
  bytes: {
    decimalDigits: 2,
  },
  currency: {
    symbol: '₹',
    decimalDigits: 0,
    thousandsSeparator: ',',
    decimalSeparator: '.',
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: false,
    showPlusSign: false,
  },
  pluralize: {
    includeNumber: false,
  },
  ordinal: {
    includeNumber: false,
  },
};

const html2text = (html) => {
  const d = document.createElement('div');
  d.innerHTML = sanitizeHTML(html);
  return d.textContent;
};

Vue.prototype.$toText = html2text;
Vue.prototype.$sanitize = sanitizeHTML;

Vue.use(Vue2Editor);
Vue.use(VeeValidate);
Vue.use(VueMoment);
Vue.use(Vue2Filters, vue2FiltersConfig);
Vue.use(VJsoneditor);

Vue.config.productionTip = false;

let app;
auth.onAuthStateChanged(async (user) => {
  let modifiedUser = null;
  try {
    if (user) {
      const {
        uid,
        email,
        displayName,
        emailVerified,
        photoURL,
        isAnonymous,
      } = user;
      modifiedUser = {
        uid,
        email,
        displayName,
        emailVerified,
        photoURL,
        isAnonymous,
      };
      await db.collection('users').doc(user.uid)
        .get().then((doc) => {
          const modifiedRoles = [];
          const data = doc.data();
          if (data) {
            const { roles } = data;
            Object.keys(roles).forEach((item) => {
              if (roles[item] === true) {
                modifiedRoles.push(item);
              }
            });
          }
          modifiedUser.roles = modifiedRoles;
        });
    }
  } catch (error) {
    console.log('Err', error);
  } finally {
    store.state.user = modifiedUser;
    if (!app) {
      app = new Vue({
        router,
        store,
        vuetify,
        render: h => h(App),
      }).$mount('#app');
    }
  }
});
